import React from 'react';

const BookingStepPersonal = ({ formData, errors, handleInputChange }) => (
  <div className="space-y-6">
    <h2 className="text-xl font-semibold text-gray-900 mb-4">Personal Information</h2>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">First Name *</label>
        <input
          type="text"
          name="firstName"
          value={formData.firstName}
          onChange={handleInputChange}
          className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-rose-500 focus:border-transparent ${
            errors.firstName ? 'border-red-500' : 'border-gray-300'
          }`}
          placeholder="Enter your first name"
        />
        {errors.firstName && <p className="text-red-500 text-xs mt-1">{errors.firstName}</p>}
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">Last Name *</label>
        <input
          type="text"
          name="lastName"
          value={formData.lastName}
          onChange={handleInputChange}
          className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-rose-500 focus:border-transparent ${
            errors.lastName ? 'border-red-500' : 'border-gray-300'
          }`}
          placeholder="Enter your last name"
        />
        {errors.lastName && <p className="text-red-500 text-xs mt-1">{errors.lastName}</p>}
      </div>
    </div>

    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">Email Address *</label>
      <input
        type="email"
        name="email"
        value={formData.email}
        onChange={handleInputChange}
        className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-rose-500 focus:border-transparent ${
          errors.email ? 'border-red-500' : 'border-gray-300'
        }`}
        placeholder="Enter your email address"
      />
      {errors.email && <p className="text-red-500 text-xs mt-1">{errors.email}</p>}
    </div>

    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">Phone Number *</label>
      <input
        type="tel"
        name="phone"
        value={formData.phone}
        onChange={handleInputChange}
        className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-rose-500 focus:border-transparent ${
          errors.phone ? 'border-red-500' : 'border-gray-300'
        }`}
        placeholder="Enter your phone number"
      />
      {errors.phone && <p className="text-red-500 text-xs mt-1">{errors.phone}</p>}
    </div>
  </div>
);

export default BookingStepPersonal;
